<template>
  <section>
    <b-row>
      <b-col md="12">
        <h2>Caracterizaciones</h2>
      </b-col>
    </b-row>
    <b-overlay :show="show" rounded="sm" variant="white">
      <b-row class="py-2">
        <b-col md="12">

          <h4 class="mt-1">Exportar Caracterizaciones</h4>
          <h6>Permite exportar las respuestas de caracterización en formato .Xlsx (Excel)</h6>
          <b-button  class="mt-3" variant="success" @click.prevent="exportarXlsx" >Exportar</b-button>

          <!-- <h4> -->
            <!-- <b-link href="" @click.prevent="exportarXlsx"><b-icon icon="file-spreadsheet"></b-icon> Exportar a excel</b-link> -->
          <!-- </h4> -->
        </b-col>
      </b-row>
    </b-overlay>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../../services/url_service'

@Component
export default class Caracterizaciones extends Vue {
  public show: boolean = false
  async exportarXlsx() {
    this.show = true
    let response = await axios.get(
      url.create('/internal/caracterizaciones/excel'),
      {
        params: {},
      }
    )
    this.show = false
    window.location.href = response.data.enlace
  }
}
</script>
